import { api } from './api';

/**
 * Chat (M-chat) merchant-side client. Each conversation here is one of THIS
 * merchant's buyer threads (`seller_kind='merchant'`, scoped server-side to the
 * merchant's user id). Polling-first, same cadence as the other apps.
 */

export type SenderKind = 'buyer' | 'seller';

export type MerchantConversationListItem = {
  id: string;
  sellerKind: 'house' | 'merchant';
  /** The buyer's name or email. */
  counterparty: string | null;
  productId: string | null;
  orderId: string | null;
  lastMessageAt: string | null;
  lastMessagePreview: string | null;
  lastMessageSenderKind: SenderKind | null;
  unread: boolean;
};

export type MerchantConversationsPage = {
  items: MerchantConversationListItem[];
  nextCursor: string | null;
};

export type ChatMessage = {
  id: string;
  senderKind: SenderKind;
  senderUserId: string | null;
  body: string;
  createdAt: string;
};

export type MessagesPage = { items: ChatMessage[]; nextCursor: string | null };

export async function listMerchantConversations(
  args: { limit?: number; cursor?: string } = {},
): Promise<MerchantConversationsPage> {
  const res = await api.get<MerchantConversationsPage>('/merchant/conversations', { params: args });
  return res.data;
}

export async function getMerchantChatUnreadCount(): Promise<{ count: number }> {
  const res = await api.get<{ count: number }>('/merchant/conversations/unread-count');
  return res.data;
}

export async function listMerchantChatMessages(
  conversationId: string,
  args: { limit?: number; cursor?: string } = {},
): Promise<MessagesPage> {
  const res = await api.get<MessagesPage>(`/merchant/conversations/${conversationId}/messages`, {
    params: args,
  });
  return res.data;
}

export async function sendMerchantChatMessage(
  conversationId: string,
  body: string,
): Promise<ChatMessage> {
  const res = await api.post<ChatMessage>(`/merchant/conversations/${conversationId}/messages`, {
    body,
  });
  return res.data;
}

export async function markMerchantConversationRead(conversationId: string): Promise<void> {
  await api.post(`/merchant/conversations/${conversationId}/read`);
}
